import { render, staticRenderFns } from "./AbrFormPageSideSection.vue?vue&type=template&id=d2c97624"
import script from "./AbrFormPageSideSection.vue?vue&type=script&lang=js"
export * from "./AbrFormPageSideSection.vue?vue&type=script&lang=js"
import style0 from "./AbrFormPageSideSection.vue?vue&type=style&index=0&id=d2c97624&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports